import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { CForm, CFormLabel, CFormInput, CFormSelect, CButton, CCard, CCardHeader, CCardBody, CInputGroup, CInputGroupText } from '@coreui/react';
import Select from 'react-select';
import { toast } from 'react-toastify';
// import MyToastify from 'src/components/MyToastify';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';



const urlApi = '/users';
const urlRouter = '/users';

const UsersCreateForm = ({ setMyData = () => { }, roleList, setRoleList, putUserRoles, userRolesList, setUserRolesList, getUserData }) => {
   const navigate = useNavigate();
   // const popup = MyToastify();

   const [username, setUsername] = useState('');
   const [plainPassword, setPlainPassword] = useState('');
   // const [roleList, setRoleList] = useState([]);
   // const [userRolesList, setUserRolesList] = useState([]);
   const [isDisabledRole, setIsDisabledRole] = useState(false);
   const [showPassword, setShowPassword] = useState(false);
   // const [email, setEmail] = useState('');
   // const [phone, setPhone] = useState('');
   // const [firstName, setFirstName] = useState('');
   // const [lastName, setLastName] = useState('');

   // const staticRoles = [
   //    { label: 'APP_USER', value: 'APP_USER' },
   //    { label: 'ROLE_SITE', value: 'ROLE_SITE' },
   //    // { label: 'ROLE_ADMIN', value:'ROLE_ADMIN'  },
   // ];


   // const [roleList, setRoleList] = useState(staticRoles)

   // const getRoleList = async () => {
   //    try {
   //       const response = await AxiosInstance.get(`/roles`);
   //       const roles = response.data.map((r) => ({ label: `${r.label} - ${r.name}`, value: r.id }));
   //       setRoleList(roles);
   //    } catch (err) {
   //       console.error('Помилка отримання списку ролей', err);
   //    }
   // };

   // useEffect(() => {
   //    getRoleList();
   // }, []);

   // Функція створення користувача
   const createUser = async () => {
      try {
         const payload = {
            username,
            plainPassword,
            // roles: userRolesList.map(role => role.label),
            // ...(userRolesList.length > 0 && { roles: userRolesList.map(role => role.label) }),
            // ...(email && { email }),
            // ...(phone && { phone }),
            // ...(firstName && { firstName }),
            // ...(lastName && { lastName }),
         };
         console.log('payload', payload)
         const response = await AxiosInstance.post(urlApi,
            payload
         );
         console.log('response', response)
         await putUserRoles(response.data);


         toast.success('Користувача створено!')
         console.log('response.data', response.data)
         // setMyData(response.data)
         // await getUserData()
         try {
            const responseData = await AxiosInstance.get(`${urlApi}/${response.data.id}`);
            setMyData(responseData.data);
         } catch (error) {
            console.error("Помилка запиту за даними користувача", error);
         }
         navigate(`/users/view/${response.data.id}`);
      } catch (err) {
         console.error('Помилка створення користувача', err);
         // popup.toastifyWarning('Помилка створення користувача');
         toast.error('Помилка створення користувача')
      }
   };



   const handleSubmit = (e) => {
      e.preventDefault();
      createUser();
   };


   return (
      <CCard className="mb-4">
         <CCardHeader>
            <strong>Створення користувача</strong>
         </CCardHeader>
         <CCardBody>
            <CForm onSubmit={handleSubmit}>
               <div className="mb-3">
                  <CFormLabel>Логін</CFormLabel>
                  {/* <CFormInput
                     value={username}
                     // onChange={(e) => setUsername(e.target.value)}
                     onChange={(e) => {
                        const value = e.target.value;
                        // тілько + спочатку і цифри після
                        if (/^\+?\d*$/.test(value) && value.length <= 13) {
                           setUsername(value);
                        }
                     }}
                     required
                     placeholder="Введіть номер у форматі +380XXXXXXXXX"
                     pattern="^\+380\d{9}$"
                     title="Введіть номер у форматі +380XXXXXXXXX"
                  /> */}
                  <CFormInput
                     value={username}
                     onChange={(e) => setUsername(e.target.value)}
                     required
                  />
               </div>
               <div className="mb-3">
                  <CFormLabel>Пароль</CFormLabel>
                  {/* <CFormInput
                     // type="password" 
                     type={showPassword ? 'text' : 'password'}
                     value={plainPassword} onChange={(e) => setPlainPassword(e.target.value)} required /> */}
                  <CInputGroup>
                     <CFormInput
                        type={showPassword ? 'text' : 'password'}
                        value={plainPassword}
                        onChange={(e) => setPlainPassword(e.target.value)}
                        required
                     />
                     <CInputGroupText
                        style={{ cursor: 'pointer' }}
                        onClick={() => setShowPassword(!showPassword)}
                     >

                        {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}

                     </CInputGroupText>
                  </CInputGroup>
               </div>
               {/* Додаткові поля */}
               {/* <div className="mb-3">
                  <CFormLabel>Email</CFormLabel>
                  <CFormInput
                     type="email"
                     value={email}
                     onChange={(e) => setEmail(e.target.value)}
                     required
                  />
               </div> */}
               {/* <div className="mb-3">
                  <CFormLabel>Телефон</CFormLabel>
                  <CFormInput
                     value={phone}
                     onChange={(e) => {
                        let val = e.target.value;
                        if (/^\+?[\d]*$/.test(val)) {
                           if (!val.startsWith('+380')) {
                              val = '+380' + val.replace(/\D/g, '').slice(0, 9);
                           } else {
                              val = '+380' + val.slice(4).replace(/\D/g, '').slice(0, 9);
                           }
                           setPhone(val);
                        }
                     }}
                     placeholder="+380XXXXXXXXX"
                     required
                  />
               </div> */}
               {/* <div className="mb-3">
                  <CFormLabel>Ім'я</CFormLabel>
                  <CFormInput
                     value={firstName}
                     onChange={(e) => setFirstName(e.target.value)}
                  />
               </div> */}
               {/* <div className="mb-3">
                  <CFormLabel>Прізвище</CFormLabel>
                  <CFormInput
                     value={lastName}
                     onChange={(e) => setLastName(e.target.value)}
                  />
               </div> */}
               <div className="mb-3">
                  <CFormLabel>Ролі</CFormLabel>
                  <Select
                     value={userRolesList}
                     isMulti
                     options={roleList}
                     // onChange={setUserRolesList}
                     // onChange={(selected) => {
                     //    // якщо вибраны обидві  ролі, лишаєм тільки останню обрану
                     //    const hasAppUser = selected.some((role) => role.label === 'APP_USER');
                     //    const hasRoleSite = selected.some((role) => role.label === 'ROLE_SITE');

                     //    if (hasAppUser && hasRoleSite) {
                     //       // лишаєм тільки останню обрану
                     //       const lastSelected = selected[selected.length - 1];
                     //       setUserRolesList([lastSelected]);
                     //    } else {
                     //       setUserRolesList(selected);
                     //    }
                     // }}
                     onChange={(selected) => setUserRolesList(selected)}
                     isDisabled={isDisabledRole}
                  />
               </div>
               <div className="d-flex justify-content-start mt-4">
                  <CButton
                     type="submit"
                     color="success" className="me-2">Створити</CButton>
                  <Link to={urlRouter}><CButton color="secondary">Відміна</CButton></Link>
               </div>
            </CForm>
         </CCardBody>
      </CCard>
   );
};

export default UsersCreateForm;